import { createContext, useContext, useEffect, useState } from "react";
import { track } from "../lib/analytics";

const CartContext = createContext(null);
const KEY = "bilgece_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (product, quantity = 1) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.product_id === product.id);
      if (ex) return prev.map((i) => i.product_id === product.id ? { ...i, quantity: i.quantity + quantity } : i);
      return [...prev, { product_id: product.id, name: product.name, slug: product.slug, cover: product.cover,
        price: product.sale_price || product.price, product_type: product.product_type, quantity }];
    });
    track("add_to_cart", { product: product.name });
  };
  const remove = (product_id) => { setItems((p) => p.filter((i) => i.product_id !== product_id)); track("remove_from_cart", {}); };
  const setQty = (product_id, quantity) => setItems((p) => p.map((i) => i.product_id === product_id ? { ...i, quantity: Math.max(1, quantity) } : i));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return <CartContext.Provider value={{ items, add, remove, setQty, clear, count, subtotal }}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
